// @flow
import type { Catalog, CatalogProperties, FileType } from 'state/types';
import { CATALOG_STORAGE_TYPE } from 'util/constants';

export function isLegalCatalogName(catalogName: string) {
  return !/[?[\]/\\=+:<>";,*|^]/.test(catalogName);
}

export function catalogNameExists(catalogs: Catalog[], catalogName: string) {
  return !!catalogs.find(
    c => c.name.toLowerCase() === catalogName.trim().toLowerCase()
  );
}

export function isVaultCatalog(catalogProperties: CatalogProperties) {
  return (
    catalogProperties.catalogDetails &&
    catalogProperties.catalogDetails.storageType === CATALOG_STORAGE_TYPE.VAULT
  );
}

export function computeFileTypeName(ft: FileType) {
  return ft.title ? ft.title : ft.extensions[0].toUpperCase();
}



// WEBPACK FOOTER //
// ./src/util/catalogUtils.js